export default [
  /**
   * Publikasi Dosen
   */
  {
    path: "/korprodi/publikasi-dosen",
    name: "korprodi-publikasi-dosen",
    component: () =>
      import("../../views/korprodi/publikasi-dosen/PublikasiDosen.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Publikasi Dosen", active: true },
      ],
      pageTitle: "Publikasi Dosen",
    },
  },
  {
    path: "/korprodi/publikasi-dosen/detail/:dosenId",
    name: "korprodi-publikasi-dosen-detail",
    component: () =>
      import("../../views/korprodi/publikasi-dosen/DetailPublikasi.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Publikasi Dosen", url: "/korprodi/publikasi-dosen" },
        { title: "Detail Publikasi", active: true },
      ],
      pageTitle: "Detail Publikasi",
    },
  },
  /**
   * Jadwal Mengajar
   */
  {
    path: "/korprodi/jadwal-mengajar",
    name: "korprodi-jadwal-mengajar",
    component: () =>
      import("../../views/korprodi/jadwal-mengajar/JadwalMengajar.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Jadwal Mengajar", active: true },
      ],
      pageTitle: "Jadwal Mengajar",
    },
  },
  {
    path: "/korprodi/jadwal-mengajar/sunting/:jadwalId",
    name: "korprodi-jadwal-mengajar-sunting",
    component: () =>
      import("../../views/korprodi/jadwal-mengajar/EditJadwal.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Jadwal Mengajar", url: "/korprodi/jadwal-mengajar" },
        { title: "Sunting Jadwal Mengajar", active: true },
      ],
      pageTitle: "Sunting Jadwal Mengajar",
    },
  },

  /**
   *  Dosen Wali
   */
  {
    path: "/korprodi/plot-dosen-wali",
    name: "plot-dosen-wali",
    component: () =>
      import("../../views/korprodi/dosen-wali/PlottingDosenWali.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Plot Dosen Wali", active: true },
      ],
      pageTitle: "Plot Dosen Wali",
    },
  },
  {
    path: "/korprodi/tambah-dosen-wali",
    name: "tambah-dosen-wali",
    component: () =>
      import("../../views/korprodi/dosen-wali/TambahPlotting.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Plot Dosen Wali", url: "/korprodi/plot-dosen-wali" },
        { title: "Tambah Dosen Wali", active: true },
      ],
      pageTitle: "Tambah Dosen Wali",
    },
  },

  /**
   *   MAHASISWA
   */

  {
    path: "/korprodi/mahasiswa",
    name: "korprodi-mahasiswa",
    component: () => import("../../views/korprodi/mahasiswa/DataMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Mahasiswa", active: true },
      ],
      pageTitle: "Mahasiswa",
    },
  },
  {
    path: "/korprodi/mahasiswa/perwalian/:mahasiswaId",
    name: "korprodi-mahasiswa-perwalian",
    component: () => import("../../views/dosen/krs-perwalian/DosenWali.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Mahasiswa", url: "/korprodi/mahasiswa" },
        { title: "Perwalian", active: true },
      ],
      pageTitle: "Perwalian",
    },
  },
  {
    path: "/korprodi/mahasiswa/cek-pembayaran/:mahasiswaId",
    name: "korprodi-cekbayar-mahasiswa",
    component: () => import("../../views/korprodi/mahasiswa/CekPembayaran.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Mahasiswa", url: "/korprodi/mahasiswa" },
        { title: "Cek Pembayaran", active: true },
      ],
      pageTitle: "Cek Pembayaran",
    },
  },
  {
    path: "/korprodi/mahasiswa/detail-mahasiswa/:mahasiswaId",
    name: "korprodi-detail-mahasiswa",
    component: () =>
      import("../../views/korprodi/mahasiswa/DetailMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Mahasiswa", url: "/korprodi/mahasiswa" },
        { title: "Detail Mahasiswa", active: true },
      ],
      pageTitle: "Detail Mahasiswa",
    },
  },
  {
    path: "/korprodi/mahasiswa-perwalian/:dosenId",
    name: "mahasiswa-perwalian",
    component: () =>
      import("../../views/korprodi/dosen-wali/PerwalianMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },

        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Plot Dosen Wali", url: "/korprodi/plot-dosen-wali" },
        { title: "Perwalian Mahasiswa", active: true },
      ],
      pageTitle: "Perwalian Mahasiswa",
    },
  },
  {
    path: "/korprodi/mahasiswa/nilai-mahasiswa/:userId",
    name: "korprodi-nilai-mahasiswa",
    component: () =>
      import("../../views/dosen/krs-perwalian/NilaiMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },

        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Mahasiswa", url: "/korprodi/mahasiswa" },
        { title: "Nilai Mahasiswa", active: true },
      ],
      pageTitle: "Nilai Mahasiswa",
    },
  },

  /**
   *  KONVERSI
   */
  {
    path: "/korprodi/konversi",
    name: "korprodi-konversi",
    component: () => import("../../views/korprodi/konversi/DataKonversi.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Konversi", active: true },
      ],
      pageTitle: "Konversi",
    },
  },

  /**
   *  KRS & PERWALIAN
   */
  {
    path: "/korprodi/krs-perwalian",
    name: "korprodi-krs-perwalian",
    component: () => import("../../views/korprodi/krs/KrsPerwalianDosen.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Krs & Perwalian", active: true },
      ],
      pageTitle: "Krs & Perwalian",
    },
  },

  {
    path: "/korprodi/krs-perwalian/detail-krs/:mahasiswaId",
    name: "korprodi-krs-detail",
    component: () => import("../../views/korprodi/krs/DetailKrsMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Krs & Perwalian", url: "/korprodi/krs-perwalian" },
        { title: "Detail KRS", active: true },
      ],
      pageTitle: "Detail KRS",
    },
  },
  /**
   *  KELAS
   */
  {
    path: "/korprodi/plot-kelas",
    name: "plot-kelas",
    component: () => import("../../views/korprodi/kelas/PlotKelas.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Plotting Kelas", active: true },
      ],
      pageTitle: "Plotting Kelas",
    },
  },
  {
    path: "/korprodi/lihat-kelas-mahasiswa/:kelasId",
    name: "lihat-kelas-mahasiswa",
    component: () => import("../../views/korprodi/kelas/LihatMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Plotting Kelas", url: "/korprodi/plot-kelas" },
        { title: "Lihat Mahasiswa", active: true },
      ],
      pageTitle: "Lihat Mahasiswa",
    },
  },
  {
    path: "/korprodi/plot-kelas-mahasiswa/:kelasId",
    name: "plot-kelas-mahasiswa",
    component: () =>
      import("../../views/korprodi/kelas/PlotKelasMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Plotting Kelas", url: "/korprodi/plot-kelas" },
        { title: "Plotting Kelas Mahasiswa", active: true },
      ],
      pageTitle: "Plotting Kelas Mahasiswa",
    },
  },

  {
    path: "/korprodi/plot-kelas-manual",
    name: "korprodi-plot-kelas-manual",
    component: () => import("../../views/korprodi/kelas/PlotKelasManual.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Plotting Kelas", url: "/korprodi/plot-kelas" },
        { title: "Plot Kelas Manual", active: true },
      ],
      pageTitle: "Plot Kelas Manual",
    },
  },
  /**
   *  KURIKULUM
   */
  {
    path: "/korprodi/kurikulum",
    name: "korprodi-kurikulum",
    component: () => import("../../views/korprodi/kurikulum/Kurikulum.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Kurikulum", active: true },
      ],
      pageTitle: "Kurikulum",
    },
  },

  {
    path: "/korprodi/kurikulum/lihat-matakuliah/:kurikulumId",
    name: "korprodi-kurikulum-matkul",
    component: () =>
      import("../../views/korprodi/kurikulum/DetailMatakuliahKurikulum.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Kurikulum", url: "/korprodi/kurikulum" },
        { title: "Detail Mata Kuliah", active: true },
      ],
      pageTitle: "Detail Mata Kuliah",
    },
  },
  /**
   * REKAP PERKULIAHAN
   */

  {
    path: "/korprodi/rekap-perkuliahan",
    name: "korprodi-rekap-perkuliahan",
    component: () =>
      import("../../views/korprodi/rekap-perkuliahan/RekapPerkuliahan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Rekap Perkuliahan", active: true },
      ],
      pageTitle: "Rekap Perkuliahan",
    },
  },

  /**
   *  TUGAS AKHIR
   */
  {
    path: "/korprodi/tugas-akhir",
    name: "korprodi-tugas-akhir",
    component: () => import("../../views/korprodi/tugasakhir/TugasAkhir.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Tugas Akhir", active: true },
      ],
      pageTitle: "Tugas Akhir",
    },
  },

  {
    path: "/korprodi/tugas-akhir/keputusan",
    name: "korprodi-tugas-akhir-keputusan",
    component: () => import("../../views/korprodi/tugasakhir/Mahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Tugas Akhir", url: "/korprodi/tugas-akhir" },
        { title: "Keputusan", active: true },
      ],
      pageTitle: "Keputusan Tugas Akhir",
    },
  },

  {
    path: "/korprodi/tugas-akhir/data-tugas-akhir",
    name: "korprodi-tugas-akhir-data",
    component: () =>
      import("../../views/korprodi/tugasakhir/DataTugasAkhir.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Tugas Akhir", url: "/korprodi/tugas-akhir" },
        { title: "Data Tugas Akhir", active: true },
      ],
      pageTitle: "Data Tugas Akhir",
    },
  },

  {
    path: "/korprodi/tugas-akhir/peminatan",
    name: "korprodi-tugas-akhir-peminatan",
    component: () => import("../../views/korprodi/tugasakhir/Peminatan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Tugas Akhir", url: "/korprodi/tugas-akhir" },
        { title: "Peminatan", active: true },
      ],
      pageTitle: "Peminatan",
    },
  },

  {
    path: "/korprodi/tugas-akhir/seminar-proposal",
    name: "korprodi-tugas-akhir-seminar-proposal",
    component: () =>
      import("../../views/korprodi/tugasakhir/SeminarProposal.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Tugas Akhir", url: "/korprodi/tugas-akhir" },
        { title: "Seminar Proposal", active: true },
      ],
      pageTitle: "Seminar Proposal",
    },
  },

  {
    path: "/korprodi/tugas-akhir/seminar-kolokium",
    name: "korprodi-tugas-akhir-seminar-kolokium",
    component: () =>
      import("../../views/korprodi/tugasakhir/SeminarKolokium.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Tugas Akhir", url: "/korprodi/tugas-akhir" },
        { title: "Seminar Kolokium", active: true },
      ],
      pageTitle: "Seminar Kolokium",
    },
  },

  {
    path: "/korprodi/tugas-akhir/seminar-yudisium",
    name: "korprodi-tugas-akhir-seminar-yudisium",
    component: () =>
      import("../../views/korprodi/tugasakhir/SeminarYudisium.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Tugas Akhir", url: "/korprodi/tugas-akhir" },
        { title: "Seminar Yudisium", active: true },
      ],
      pageTitle: "Seminar Yudisium",
    },
  },

  {
    path: "/korprodi/tugas-akhir/pembimbing",
    name: "korprodi-tugas-akhir-pembimbing",
    component: () =>
      import("../../views/korprodi/tugasakhir/DaftarPengajuan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Tugas Akhir", url: "/korprodi/tugas-akhir" },

        { title: "Pembimbing ", active: true },
      ],
      pageTitle: "Pembimbing",
    },
  },

  {
    path: "/korprodi/tugas-akhir/non-pembimbing",
    name: "korprodi-tugas-akhir-non-pembimbing",
    component: () =>
      import(
        "../../views/korprodi/tugasakhir/DaftarPengajuanNonPembimbing.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Tugas Akhir", url: "/korprodi/tugas-akhir" },

        { title: "Koorprodi Daftar Proposal", active: true },
      ],
      pageTitle: "Koorprodi Daftar Proposal",
    },
  },

  {
    path: "/korprodi/tugas-akhir/daftar-mahasiswa-pembimbing",
    name: "korprodi-tugas-akhir-daftar-mahasiswa-pembimbing",
    component: () =>
      import("../../views/korprodi/tugasakhir/DaftarMahasiswaPembimbing.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Tugas Akhir", url: "/korprodi/tugas-akhir" },

        { title: "Daftar Mahasiswa Pembimbing", active: true },
      ],
      pageTitle: "Daftar Mahasiswa Pembimbing",
    },
  },
  /*
  #Tahap 1 Daftar TA {backend komponen router link ke halaman daftar proposal}
*/
  {
    path: "/korprodi/tugas-akhir/daftar-TA",
    name: "korprodi-tugas-akhir-daftar-TA",
    component: () => import("../../views/korprodi/tugasakhir/DaftarTA.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Tugas Akhir", url: "/korprodi/tugas-akhir" },

        { title: "Korprodi Daftarkan TA Mahasiswa", active: true },
      ],
      pageTitle: "Korprodi Daftarkan TA Mahasisawa ",
    },
  },
  /*
  #Tahap 2 Daftar Kolokium {backend komponen router link ke halaman kolokium}
*/
  // {
  //     component: ()=>
  //       import(
  //         "../../views/korprodi/tugasakhir/DaftarKolokium"
  //       ),
  //     path: "/korprodi/tugas-akhir/daftar-kolokium",
  //     name: "korprodi-tugas-akhir-daftar-kolokium",
  //     meta:{
  //       breadcrumb: [
  //         {title: "Home", url: "/apps"},
  //         {title: "Korprodi", url: "/submenu/korprodi"},
  //         {title: "Tugas Akhir", url: "/korprodi/tugas-akhir"},
  //         {title: "Korprodi Daftarkan Kolokium Mahasiswa", active: true},
  //       ],
  //     pageTitle:"Korprodi Daftarkan Kolokium Mahasiswa",

  //     }
  // },
  /* 
  #Tahap 3 Daftar Yudisium {backend komponen router link ke halaman yudisium}
*/
  // {
  //     component: ()=>
  //     import(
  //       "../../views/korprodi/tugasakhir/DaftarYudisium"
  //     ),
  //     path: "/korprodi/tugas-akhir/daftar-yudisium",
  //     name: "korprodi-tugas-akhir-daftar-yudisium",
  //     meta:{
  //       breadcrumb:[
  //         {title: "Home", url: "apps"},
  //         {title: "Korprodi", url: "/submenu/korprodi"},
  //         {title: "Tugas Akhir", url: "/korprodi/tugas-akhir"},
  //         {title: "Korprodi Daftarkan Yudisium Mahasiswa", active: true},
  //       ],
  //     pageTitle:"Korprodi Daftar Yudisium Mahasiswa",

  //     }
  // },
  {
    path: "/korprodi/tugas-akhir/plot-pembimbing/:tugasAkhirId",
    name: "korprodi-tugas-akhir-plot-pembimbing",
    component: () =>
      import("../../views/korprodi/tugasakhir/PlotPembimbing.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Tugas Akhir", url: "/korprodi/tugas-akhir" },
        {
          title: "Pembimbing ",
          url: "/korprodi/tugas-akhir/pembimbing",
        },
        { title: "Plot Pembimbing ", active: true },
      ],
      pageTitle: "Plot Pembimbing",
    },
  },
  /**
   *  MATAKULIAH
   */
  {
    path: "/korprodi/matakuliah",
    name: "korprodi-mata-kuliah",
    component: () => import("../../views/korprodi/matakuliah/Matakuliah.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Matakuliah", active: true },
      ],
      pageTitle: "Matakuliah",
    },
  },

  {
    path: "/korprodi/matakuliah/plot-matakuliah",
    name: "korprodi-plot-mata-kuliah",
    component: () =>
      import("../../views/korprodi/matakuliah/PlotMatakuliahDosen.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Matakuliah", url: "/korprodi/matakuliah" },

        { title: "Plot Matakuliah", active: true },
      ],
      pageTitle: "Plot Matakuliah",
    },
  },

  {
    path: "/korprodi/matakuliah/nil-peserta",
    name: "korprodi-matakuliah-nil-peserta",
    component: () => import("../../views/korprodi/matakuliah/NilPeserta.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Matakuliah", url: "/korprodi/matakuliah" },

        { title: "Matakuliah Nil Peserta", active: true },
      ],
      pageTitle: "Matakuliah Nil Peserta",
    },
  },
  {
    path: "/korprodi/matakuliah/grouping-matakuliah",
    name: "korprodi-grouping-mata-kuliah",
    component: () =>
      import("../../views/korprodi/matakuliah/GroupingMatkul.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Matakuliah", url: "/korprodi/matakuliah" },

        { title: "Grouping Matakuliah", active: true },
      ],
      pageTitle: "Grouping Matakuliah",
    },
  },

  {
    path: "/korprodi/matakuliah/lihat-matakuliah/:dosenId",
    name: "korprodi-lihat-mata-kuliah",
    component: () =>
      import("../../views/korprodi/matakuliah/LihatMatakuliah.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Matakuliah", url: "/korprodi/matakuliah" },
        { title: "Lihat Matakuliah", active: true },
      ],
      pageTitle: "Lihat Matakuliah",
    },
  },

  /**
   *  TURNITIN
   */
  {
    path: "/korprodi/turnitin",
    name: "korprodi-turnitin",
    component: () =>
      import("../../views/korprodi/turnitin-mahasiswa/TurnitinMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Turnitin Mahasiswa", active: true },
      ],
      pageTitle: "Turnitin Mahasiswa",
    },
  },

  /**
   *  NILAI
   */
  {
    path: "/korprodi/nilai",
    name: "korprodi-nilai",
    component: () => import("../../views/korprodi/nilai/NilaiMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Nilai Mahasiswa", active: true },
      ],
      pageTitle: "Nilai Mahasiswa",
    },
  },
  /**
   *  AKTIVITAS MAHASISWA
   */
  {
    path: "/korprodi/aktivitas-mahasiswa",
    name: "korprodi-aktivitas-mahasiswa",
    component: () =>
      import("../../views/korprodi/aktivitas-mahasiswa/AktivitasMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Aktivitas Mahasiswa", active: true },
      ],
      pageTitle: "Aktivitas Mahasiswa",
    },
  },
  {
    path: "/korprodi/aktivitas-mahasiswa/tambah-aktivitas",
    name: "korprodi-aktivitas-mahasiswa-tambah",
    component: () =>
      import(
        "../../views/korprodi/aktivitas-mahasiswa/TambahAktivitasMahasiswa.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Aktivitas Mahasiswa", url: "/korprodi/aktivitas-mahasiswa" },
        { title: "Tambah Aktivitas Mahasiswa", active: true },
      ],
      pageTitle: "Tambah Aktivitas Mahasiswa",
    },
  },
  {
    path: "/korprodi/aktivitas-mahasiswa/tambah-peserta/:aktivitasId",
    name: "korprodi-aktivitas-mahasiswa-tambah-peserta",
    component: () =>
      import(
        "../../views/korprodi/aktivitas-mahasiswa/TambahPesertaAktivitas.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Aktivitas Mahasiswa", url: "/korprodi/aktivitas-mahasiswa" },
        { title: "Tambah Peserta Aktivitas", active: true },
      ],
      pageTitle: "Tambah Peserta Aktivitas",
    },
  },
  {
    path: "/korprodi/aktivitas-mahasiswa/sunting-peserta/:aktivitasId",
    name: "korprodi-aktivitas-mahasiswa-sunting-peserta",
    component: () =>
      import(
        "../../views/korprodi/aktivitas-mahasiswa/EditPesertaAktivitas.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "Aktivitas Mahasiswa", url: "/korprodi/aktivitas-mahasiswa" },
        { title: "Sunting Peserta Aktivitas", active: true },
      ],
      pageTitle: "Sunting Peserta Aktivitas",
    },
  },
  {
    path: "/korprodi/krs-ta-sp",
    name: "korprodi-krs-ta-sp",
    component: () => import("../../views/korprodi/krs/KRSTugasAkhir.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Korprodi", url: "/submenu/korprodi" },
        { title: "KRS TA", active: true },
      ],
      pageTitle: "KRS TA",
    },
  },
];
